/**
 * 点位信息实体
 * zxw
 * 2025-05-20
 */

import { useEffect, useState } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Divider,
    InputNumber,
    Radio,
    DatePicker,
    Image,
    Upload,
    Select,
    Typography,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import $ from 'jquery';
import {
    AddRequestHeaders,
    winHeight,
    uploadImageButton,
    GetBase64,
    UjoinParams,
    AliyunOSSclient,
    AliyunOSSDelete,
} from '../../incs/FunHelper';

import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dateLocale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';

const { Text } = Typography;

var date = new Date();
var month = date.getMonth() + 1;
var strDate = date.getDate();
if (month >= 1 && month <= 9) {
    month = '0' + month;
}
if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate;
}
const CURRENTDATE = date.getFullYear() + '-' + month + '-' + strDate;

const MODULENAME = '点位信息';
const { TextArea } = Input;

const Entity = (props) => {
    const { open, setOpen, record, refresh, preGroup, collectLists } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [ulid, setUlid] = useState('');
    const [collectUlid, setCollectUlid] = useState('');   // 点位采集Ulid
    const [number, setNumber] = useState('');   // 点位编号
    const [name, setName] = useState('');   // 点位名称
    const [policeStation, setPoliceStation] = useState(''); //  所属派出所
    const [address, setAddress] = useState(''); // 点位详细地址
    // const [rodDeviceCount, setRodDeviceCount] = useState(0); //  一杆几机
    const [highBall, setHighBall] = useState(0); // 智能球
    const [doubleCabins, setDoubleCabins] = useState(0);  // 双舱
    const [doublePinyin, setDoublePinyin] = useState(0);  // 双拼
    const [vehicleCheckpoint, setVehicleCheckpoint] = useState(0); //  车辆卡口/大卡
    const [oldEquipment, setOldEquipment] = useState(0); //  利旧
    const [intelligentBox, setIntelligentBox] = useState(1); // 智能箱
    const [installationMethod, setInstallationMethod] = useState(CNF.installationMethod[0].value);  // 安装方式
    const [rodType, setRodType] = useState(''); // 杆型
    const [installationHeight, setInstallationHeight] = useState('');    // 安装高度
    const [rodHeight, setRodHeight] = useState(0); // 杆高
    const [armLength, setArmLength] = useState(''); // 臂长
    const [armOrientation, setArmOrientation] = useState(''); // 臂朝向
    const [controlArea, setControlArea] = useState(''); //  防控区域
    const [connectElectricityMethod, setConnectElectricityMethod] = useState(''); // 接电方式
    const [dirtRoad, setDirtRoad] = useState(0); // 泥土路面
    const [cementRoad, setCementRoad] = useState(0); // 水泥路面
    const [asphaltRoad, setAsphaltRoad] = useState(0); //   沥青路面
    const [sidewalk, setSidewalk] = useState(0); // 人行道
    const [powerSupplyLength, setPowerSupplyLength] = useState(0); // 电源长度
    const [connectElectricityLocation, setConnectElectricityLocation] = useState(''); //    接电位置
    const [collectionDate, setCollectionDate] = useState(CURRENTDATE);   // 采集日期
    const [longitudeLatitude, setLongitudeLatitude] = useState(''); // 经纬度
    const [description, setDescription] = useState(''); // 备注

    // 安装位置图片
    const [fileILIPList, setFileILIPList] = useState([]);
    const [deleteFileILIPList, setDeleteFileILIPList] = useState([]);
    const [previewILIPOpen, setPreviewILIPOpen] = useState(false);
    const [previewILIPImage, setPreviewILIPImage] = useState('');

    // 接电位置图片
    const [fileCELIPList, setFileCELIPList] = useState([]);
    const [deleteFileCELIPList, setDeleteFileCELIPList] = useState([]);
    const [previewCELIPOpen, setPreviewCELIPOpen] = useState(false);
    const [previewCELIPImage, setPreviewCELIPImage] = useState('');

    // 修改初始化数据
    useEffect(() => {
        if (open && record) {
            setCollectUlid(record.collect_ulid)
            setNumber(record.number);
            setName(record.name);
            setPoliceStation(record.police_station);
            setAddress(record.address);
            setHighBall(record.high_ball);
            setDoubleCabins(record.double_cabins);
            setDoublePinyin(record.double_pinyin);
            setVehicleCheckpoint(record.vehicle_checkpoint);
            setOldEquipment(record.old_equipment);
            setIntelligentBox(record.intelligent_box);
            setInstallationMethod(record.installation_method);
            setRodType(record.rod_type);
            setInstallationHeight(record.installation_height);
            setRodHeight(record.rod_height);
            setArmLength(record.arm_length);
            setArmOrientation(record.arm_orientation);
            setControlArea(record.control_area);
            setConnectElectricityMethod(record.connect_electricity_method);
            setDirtRoad(record.dirt_road);
            setCementRoad(record.cement_road);
            setAsphaltRoad(record.asphalt_road);
            setSidewalk(record.sidewalk);
            setPowerSupplyLength(record.power_supply_length);
            setConnectElectricityLocation(record.connect_electricity_location);
            setCollectionDate(record.collection_date);
            setLongitudeLatitude(record.longitude_latitude);
            setDescription(record.description);
        }
    }, [open, record]);

    // 修改初始化图片
    useEffect(() => {
        /**
         * 获取图片对象
         * @param {*} path 
         * @param {*} tag 
         */
        const getImageObj = (path, tag) => {
            let params = { 'acl': 'GetObject' }
            $.ajax({
                url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        const token = data.dat;
                        try {
                            let arr = path.split('/');
                            //  去掉路径‘/’
                            let result = AliyunOSSclient(token).signatureUrl(path, {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + arr[arr.length - 1] + '"'
                                }
                            });
                            let newFileList = [];
                            newFileList.push({
                                url: result,
                                preview: result,
                                status: 'done',
                                percent: 100,
                                path: path,
                            });
                            tag === "ILIP" ? setFileILIPList(newFileList) : setFileCELIPList(newFileList);
                        } catch (e) {
                            // console.log(e);
                        }
                    } else {
                        message.error(data.msg, CNF.messageDuration);
                    }
                }
            });
        }
        if (open && record && record.key !== ulid) {
            setUlid(record.key);
            if (record.installation_location_image_path && fileILIPList.length < 1) {
                getImageObj(record.installation_location_image_path, 'ILIP');
            }
            if (record.connect_electricity_location_image_path && fileCELIPList.length < 1) {
                getImageObj(record.connect_electricity_location_image_path, 'CELIP');
            }
        }
    }, [open, record, ulid, fileILIPList, fileCELIPList]);

    const quit = () => {
        setLoading(false);
        setOpen(false);
        setUlid('');
        setCollectUlid('');
        setNumber('');
        setName('');
        setPoliceStation('');
        setAddress('');
        setHighBall(0);
        setDoubleCabins(0);
        setDoublePinyin(0);
        setVehicleCheckpoint(0);
        setOldEquipment(0);
        setIntelligentBox(1);
        setInstallationMethod(CNF.installationMethod[0].value);
        setRodType('');
        setInstallationHeight('');
        setRodHeight(0);
        setArmLength(0);
        setArmOrientation('');
        setControlArea('');
        setConnectElectricityMethod('');
        setDirtRoad(0);
        setCementRoad(0);
        setAsphaltRoad(0);
        setSidewalk(0);
        setPowerSupplyLength(0);
        setConnectElectricityLocation('');
        setCollectionDate(CURRENTDATE);
        setLongitudeLatitude('');
        setDescription('');

        setFileILIPList([]);
        setDeleteFileILIPList([]);
        setPreviewILIPOpen(false);
        setPreviewILIPImage('');

        setFileCELIPList([]);
        setDeleteFileCELIPList([]);
        setPreviewCELIPOpen(false);
        setPreviewCELIPImage('');
    };

    const cancel = () => {
        if (!record) {
            //  新增情况下取消，则删除已上传的图片
            aliyunOSSDeleteFileList(fileILIPList);
            aliyunOSSDeleteFileList(deleteFileILIPList);
            aliyunOSSDeleteFileList(fileCELIPList);
            aliyunOSSDeleteFileList(deleteFileCELIPList);
        } else {
            //  修改情况下取消，删除新增已上传的文件
            //  安装位置图片
            for (let i = 0; i < fileILIPList.length; i++) {
                if (fileILIPList[i].path !== record.installation_location_image_path) {
                    //  如果不是原始图片则删除
                    AliyunOSSDelete(fileILIPList[i]);
                }
            }
            //  接电位置图片
            for (let i = 0; i < fileCELIPList.length; i++) {
                if (fileCELIPList[i].path !== record.connect_electricity_location_image_path) {
                    //  如果不是原始图片则删除
                    AliyunOSSDelete(fileCELIPList[i]);
                }
            }
        }
        quit();
    };

    const ok = () => {
        //  参数校验
        if (collectUlid === '') {
            message.error(MODULENAME + '点位采集不能为空！', CNF.messageDuration);
            return;
        }
        if (number === '') {
            message.error(MODULENAME + '编码不能为空！', CNF.messageDuration);
            return;
        }
        if (name === '') {
            message.error(MODULENAME + '名称不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'pointLocations/infos' + (record ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'collect_ulid': collectUlid,
                'number': number,
                'police_station': policeStation,
                'name': name,
                'address': address,
                'rod_device_count': (parseInt(highBall) + parseInt(doubleCabins) + parseInt(doublePinyin) + parseInt(vehicleCheckpoint) + parseInt(oldEquipment)).toString(),
                'high_ball': highBall.toString(),
                'double_pinyin': doublePinyin.toString(),
                'double_cabins': doubleCabins.toString(),
                'vehicle_checkpoint': vehicleCheckpoint.toString(),
                'old_equipment': oldEquipment.toString(),
                'intelligent_box': intelligentBox.toString(),
                'installation_method': installationMethod,
                'rod_type': rodType,
                'installation_height': installationHeight,
                'rod_height': rodHeight.toString(),
                'arm_length': armLength,
                'arm_orientation': armOrientation,
                'control_area': controlArea,
                'dirt_road': dirtRoad.toString(),
                'cement_road': cementRoad.toString(),
                'asphalt_road': asphaltRoad.toString(),
                'sidewalk': sidewalk.toString(),
                'connect_electricity_method': connectElectricityMethod,
                'power_supply_length': powerSupplyLength,
                'connect_electricity_location': connectElectricityLocation,
                'longitude_latitude': longitudeLatitude,
                'collection_date': collectionDate,
                'description': description,
                'installation_location_image_path': fileILIPList.length > 0 ? fileILIPList[0].path : '',
                'connect_electricity_location_image_path': fileCELIPList.length > 0 ? fileCELIPList[0].path : ''
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            if (data.status === 422) {
                messageApi.error(data.statusText, CNF.messageDuration);
            } else {
                messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            }
        }).always(function () {
            setTimeout(function () {
                setLoading(false);
            }, CNF.messageDuration * 1000);
        })
    };

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const preview = (file, tag) => {
        if (!file.preview) {
            if (file.originFileObj) {
                //  转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        tag === 'ILIP' ? setPreviewILIPImage(file.preview || file.url) : setPreviewCELIPImage(file.preview || file.url);
        tag === 'ILIP' ? setPreviewILIPOpen(file.preview || file.url) : setPreviewCELIPOpen(file.preview || file.url);
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, tag, acl = 'private') => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': acl
        }
        let params = {
            'acl': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                const token = data.dat;
                try {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                        //  路径由以下部分组成
                        //  项目代码+组织前缀+pointLocation+uuid+附件名（去除空格）
                        let path = CNF.projectCode.toLowerCase()
                        path += '/pointLocations';
                        path += '/' + preGroup;
                        path += '/' + collectUlid;
                        path += '/' + file.name.replace(/\s/g, '');
                        //  获取最新的文件列表
                        var newFileList = tag === "ILIP" ? [...fileILIPList] : [...fileCELIPList];
                        AliyunOSSclient(token).multipartUpload(path, file,
                            {
                                //  请求头
                                headers,
                                //  获取分片上传进度、断点和返回值
                                progress: (p) => {
                                    tag === "ILIP" ? setFileILIPList(prevItems => {
                                        let newItems = [...prevItems]; // 创建数组的副本
                                        newItems[newItems.length - 1] = {
                                            ...newItems[newItems.length - 1],
                                            percent: parseInt(p * 100),
                                            status: p === 1 ? 'done' : 'uploading',
                                            url: CNF.ossApi + path,
                                            path: path,
                                        }; // 更新对象
                                        return newItems; // 返回新的数组
                                    }) : setFileCELIPList(prevItems => {
                                        let newItems = [...prevItems]; // 创建数组的副本
                                        newItems[newItems.length - 1] = {
                                            ...newItems[newItems.length - 1],
                                            percent: parseInt(p * 100),
                                            status: p === 1 ? 'done' : 'uploading',
                                            url: CNF.ossApi + path,
                                            path: path,
                                        }; // 更新对象
                                        return newItems; // 返回新的数组
                                    })
                                },
                                //  分片数量
                                parallel: Math.ceil(file.size / 1024 / 1024),
                                //  设置分片大小，默认为1M。
                                partSize: 1024 * 1024,
                                mime: "text/plain",
                            }).then((result) => {
                                //  上传成功
                                if (result.res.status === 200) {
                                    //  更新文件列表，并将图片列表是否改变置为1
                                }
                            }).catch((e) => {
                                //  上传失败
                                message.error(file.name + ' 上传失败！', CNF.messageDuration);
                                tag === "ILIP" ? setFileILIPList(newFileList.pop()) : setFileCELIPList(newFileList.pop());
                            });
                    }
                } catch (e) {
                    // console.log(e);
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        })
    }

    /**
     * 删除图片列表
     * @param {*} deleteFileArr 
     */
    const aliyunOSSDeleteFileList = (deleteFileArr) => {
        for (let file of deleteFileArr) {
            //  从阿里云上删除
            AliyunOSSDelete(file);
        }
    }
    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            message.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 104857600) {
            message.error('上传附近超过10M，建议拆分文件！', CNF.messageDuration);
            return false;
        }
        //  上传图片之前，需要确定所属点位采集
        if (!collectUlid) {
            message.error('请选择点位采集！', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 上传图片
     * @param {*} file 
     * @param {*} tag
     */
    const uploadImage = (file, tag) => {
        //  图片上传至阿里云前动作
        aliyunOSSUpload(file, tag);
    }


    return (
        <div>
            {contextHolder}
            <Modal
                width={960}
                style={{ top: 0, maxHeight: winHeight }}
                title={(record ? '修改' : '创建') + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >
                <div style={{ maxHeight: winHeight - 150, overflowY: 'auto', paddingRight: 10 }}>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={4}>所属点位采集<Text type='danger'>*</Text>：</Col>
                        <Col span={10}>
                            <Select
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={collectUlid || undefined}
                                onChange={(value) => setCollectUlid(value)}
                                disabled={loading}
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                options={collectLists && collectLists.map((item) => ({
                                    key: item.key,
                                    value: item.key,
                                    label: item.name,
                                }))}
                            />
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>1.基本信息</Divider>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={4}>点位编号<Text type='danger'>*</Text>：</Col>
                        <Col span={5}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setNumber(e.target.value)}
                                value={number}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>点位名称<Text type='danger'>*</Text>：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4} >所属派出所：</Col>
                        <Col span={5}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setPoliceStation(e.target.value)}
                                value={policeStation}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>点位详细地址：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setAddress(e.target.value)}
                                value={address}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>2.设备配置</Divider>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={4}>一杆几机：</Col>
                        <Col span={5}>
                            <InputNumber
                                style={{ width: '100%' }}
                                // onChange={(value) => setRodDeviceCount(value)}
                                value={parseInt(highBall) + parseInt(doubleCabins) + parseInt(doublePinyin) + parseInt(vehicleCheckpoint) + parseInt(oldEquipment)}
                                min={0}
                                step={1}
                                disabled={true}
                            />
                        </Col>
                        <Col span={4} offset={1}>机型选择：</Col>
                        <Col span={10}>
                            <Row>
                                <Col span={4}>双舱：</Col>
                                <Col span={7}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setDoubleCabins(value)}
                                            value={doubleCabins}
                                            min={0}
                                            step={1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>个</Space.Addon>
                                    </Space.Compact>
                                </Col>
                                <Col span={6} offset={1}>球机：</Col>
                                <Col span={6}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setHighBall(value)}
                                            value={highBall}
                                            min={0}
                                            step={1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>个</Space.Addon>
                                    </Space.Compact>

                                </Col>
                            </Row>
                            <Row style={{ marginTop: CNF.rowMarginTop }}>
                                {/* <Col span={4}>双拼：</Col>
                                <Col span={7}>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        addonAfter="个"
                                        onChange={(value) => setDoublePinyin(value)}
                                        value={doublePinyin}
                                        min={0}
                                        step={1}
                                        disabled={loading}
                                    />
                                </Col> */}
                                <Col span={4}>利旧：</Col>
                                <Col span={7}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setOldEquipment(value)}
                                            value={oldEquipment}
                                            min={0}
                                            step={1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>个</Space.Addon>
                                    </Space.Compact>

                                </Col>
                                <Col span={6} offset={1}>大卡：</Col>
                                <Col span={6}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setVehicleCheckpoint(value)}
                                            value={vehicleCheckpoint}
                                            min={0}
                                            step={1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>个</Space.Addon>
                                    </Space.Compact>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4}>智能箱：</Col>
                        <Col span={5}>
                            <InputNumber
                                style={{ width: '100%' }}
                                onChange={(value) => setIntelligentBox(value)}
                                value={intelligentBox}
                                min={0}
                                step={1}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>安装方式：</Col>
                        <Col span={10}>
                            <Radio.Group
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                                size="small"
                                value={installationMethod}
                                onChange={(e) => setInstallationMethod(e.target.value)}
                                options={CNF.installationMethod}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4}>杆型：</Col>
                        <Col span={5}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setRodType(e.target.value)}
                                value={rodType}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>安装高度：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setInstallationHeight(e.target.value)}
                                value={installationHeight}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4}>杆高：</Col>
                        <Col span={5}>
                            <Space.Compact>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    onChange={(value) => setRodHeight(value)}
                                    value={rodHeight}
                                    min={0}
                                    step={0.1}
                                    disabled={loading}
                                />
                                <Space.Addon>米</Space.Addon>
                            </Space.Compact>
                        </Col>
                        <Col span={4} offset={1}>臂长：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setArmLength(e.target.value)}
                                value={armLength}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4}>臂朝向：</Col>
                        <Col span={5}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setArmOrientation(e.target.value)}
                                value={armOrientation}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>防控区域：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setControlArea(e.target.value)}
                                value={controlArea}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>3.施工信息</Divider>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={4}>接电方式：</Col>
                        <Col span={5}>
                            <Input
                                placeholder='请输入'
                                value={connectElectricityMethod}
                                onChange={(e) => setConnectElectricityMethod(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>路面开挖长度：</Col>
                        <Col span={10}>
                            <Row>
                                <Col span={6}>泥土路面：</Col>
                                <Col span={18}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setDirtRoad(value)}
                                            value={dirtRoad}
                                            min={0}
                                            step={0.1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>米</Space.Addon>
                                    </Space.Compact>

                                </Col>
                            </Row>
                            <Row style={{ marginTop: CNF.rowMarginTop }}>
                                <Col span={6}>水泥路面：</Col>
                                <Col span={18}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setCementRoad(value)}
                                            value={cementRoad}
                                            min={0}
                                            step={0.1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>米</Space.Addon>
                                    </Space.Compact>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: CNF.rowMarginTop }}>
                                <Col span={6}>沥青路面：</Col>
                                <Col span={18}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setAsphaltRoad(value)}
                                            value={asphaltRoad}
                                            min={0}
                                            step={0.1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>米</Space.Addon>
                                    </Space.Compact>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: CNF.rowMarginTop }}>
                                <Col span={6}>人行道：</Col>
                                <Col span={18}>
                                    <Space.Compact>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            onChange={(value) => setSidewalk(value)}
                                            value={sidewalk}
                                            min={0}
                                            step={0.1}
                                            disabled={loading}
                                        />
                                        <Space.Addon>米</Space.Addon>
                                    </Space.Compact>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={4}>电源长度：</Col>
                        <Col span={5}>
                            <Space.Compact>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    onChange={(value) => setPowerSupplyLength(value)}
                                    value={powerSupplyLength}
                                    min={0}
                                    step={0.1}
                                    disabled={loading}
                                />
                                <Space.Addon>米</Space.Addon>
                            </Space.Compact>
                        </Col>
                        <Col span={4} offset={1}>接电位置：</Col>
                        <Col span={10}>
                            <Input
                                placeholder='请输入'
                                onChange={(e) => setConnectElectricityLocation(e.target.value)}
                                value={connectElectricityLocation}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>4.地里与时间信息</Divider>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={4}>采集日期：</Col>
                        <Col span={5}>
                            <DatePicker
                                onChange={(_, dateString) => { setCollectionDate(dateString ? dateString : CURRENTDATE) }}
                                placeholder='请选择日期'
                                value={dayjs(collectionDate, 'YYYY-MM-DD')}
                                style={{ width: '100%' }}
                                locale={dateLocale}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={4} offset={1}>经纬度：</Col>
                        <Col span={10}>
                            <Input
                                placeholder="经纬度用逗号隔开"
                                onChange={(e) => setLongitudeLatitude(e.target.value)}
                                value={longitudeLatitude}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>5.图片信息</Divider>
                    <Row style={{ lineHeight: 2.2 }}>
                        <Col span={12}>安装位置：</Col>
                        <Col span={12}>接电位置：</Col>
                    </Row>
                    <Row style={{ lineHeight: 2.2, marginTop: CNF.rowMarginTop }}>
                        <Col span={12}>
                            <Upload
                                beforeUpload={beforeUpload}
                                name='file'
                                listType='picture-card'
                                icon={<PlusOutlined />}
                                customRequest={(option) => { uploadImage(option.file, 'ILIP'); }}
                                fileList={fileILIPList}
                                onPreview={(file) => { preview(file, 'ILIP') }}
                                disabled={loading}
                                onChange={({ fileList: newFileList }) => {
                                    setFileILIPList(newFileList)
                                }}
                                onRemove={(file) => {
                                    let deleteFileList = deleteFileILIPList;
                                    deleteFileList.push(file);
                                    setDeleteFileILIPList(deleteFileList);
                                }}
                            >
                                {fileILIPList.length >= CNF.pointLocationImageMaxCount ? null : uploadImageButton}
                            </Upload>
                            {previewILIPImage && (
                                <Image
                                    wrapperStyle={{ display: 'none', }}
                                    preview={{
                                        visible: previewILIPOpen,
                                        onVisibleChange: (visible) => setPreviewILIPOpen(visible),
                                        afterOpenChange: (visible) => !visible && setPreviewILIPImage(''),
                                    }}
                                    src={previewILIPImage}
                                    disabled={loading}
                                />
                            )}
                        </Col>
                        <Col span={12}>
                            <Upload
                                beforeUpload={beforeUpload}
                                name='file'
                                listType='picture-card'
                                icon={<PlusOutlined />}
                                customRequest={(option) => { uploadImage(option.file, 'CELIP'); }}
                                fileList={fileCELIPList}
                                onPreview={(file) => { preview(file, 'CELIP') }}
                                disabled={loading}
                                onChange={({ fileList: newFileList }) => {
                                    setFileCELIPList(newFileList)
                                }}
                                onRemove={(file) => {
                                    let deleteFileList = deleteFileILIPList;
                                    deleteFileList.push(file);
                                    setDeleteFileCELIPList(deleteFileList);
                                }}
                            >
                                {fileCELIPList.length >= CNF.pointLocationImageMaxCount ? null : uploadImageButton}
                            </Upload>
                            {previewCELIPImage && (
                                <Image
                                    wrapperStyle={{ display: 'none', }}
                                    preview={{
                                        visible: previewCELIPOpen,
                                        onVisibleChange: (visible) => setPreviewCELIPOpen(visible),
                                        afterOpenChange: (visible) => !visible && setPreviewCELIPImage(''),
                                    }}
                                    src={previewCELIPImage}
                                    disabled={loading}
                                />
                            )}
                        </Col>
                    </Row>
                    <Divider titlePlacement='start' plain>6.备注</Divider>
                    <Row style={{ marginTop: CNF.rowMarginTop }}>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                autoSize={{ minRows: 4, maxRows: 4 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    );
};

export default Entity